// TODO: rename vars to PurchaseConfirmation
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import SiteNav from '../SiteNav';
import LegalFooter from '../LegalFooter';

import { useScrollToTop } from '@evdy/web-core/dist/customHooks';
import { useGetWebleadFromCookie } from '../../customHooks';

import { checkoutCompleted } from '../../klaviyoActions';

import styles from './PurchaseConfirmation.module.scss';

import purpleLoveHeart from '../../public/images/purple-love-heart-icon.svg';

const {
  'preparing-package': preparingPackageClass,
  'preparing-package-content': preparingPackageContentClass
} = styles;

const PurchaseConfirmation = () => {
  const { authUser = {}, purchaseFlow = {} } = useSelector(({ authUser, webPurchase }) => ({
    authUser,
    purchaseFlow: webPurchase?.purchaseFlow
  }));

  // assign most prioritized user data
  const { data: userData } = useMemo(() => {
    return !!authUser?.data?._id ? authUser : purchaseFlow;
  }, [authUser, purchaseFlow]);

  const { email, eFuneral } = userData || {};
  const { packageData: { name: packageName } = {}, paymentOption, funeralHomeId } = eFuneral || {};
  const { years: termYears, premiumAmount: priceMonthly, faceAmount: priceTotal } =
    paymentOption ?? {};
  const { name: providerName, address: providerAddress } = funeralHomeId ?? {};

  // scroll to top on mount
  useScrollToTop();

  // on mount, check if weblead cookie exists and fetch existing weblead
  useGetWebleadFromCookie();

  // track sale complete
  useEffect(() => {
    checkoutCompleted({
      packageName,
      term: termYears * 12,
      priceMonthly,
      priceTotal,
      providerName,
      providerAddress
    });
  }, [packageName, priceMonthly, priceTotal, providerAddress, providerName, termYears]);

  return (
    <div className={preparingPackageClass}>
      <SiteNav />
      <div className={preparingPackageContentClass}>
        <img src={purpleLoveHeart} alt="heart-icon" />
        <h3>Thank you and congrats on your purchase!</h3>
        <p>
          Thank you for your order! We are working with {providerName || 'the home'} to finalize
          your purchase.
          <br />
          <br />
          You will receive an email shortly {!!email ? `at ${email}` : ''} confirming the details of
          your purchase. In the meantime if you need support, feel free to contact us at{' '}
          <a href="mailto:care@everdays.com">care@everdays.com</a>
        </p>
      </div>
      <LegalFooter />
    </div>
  );
};

export default PurchaseConfirmation;
